import { authenticatedAxios } from "lib/actions/fetcher";
import { endpointsIssues } from "lib/actions/endpoints/endpointsIssues";
import { IssueResponseModel } from "components/modules/Issues/lib/types/IssueResponseModel";
import { Operation } from "fast-json-patch";

export async function issuePatch(
  projectId: number,
  issueId: string,
  patch: Operation[],
): Promise<IssueResponseModel> {
  if (!patch.length) return;
  const response = await authenticatedAxios.request<IssueResponseModel>({
    ...endpointsIssues.projectIssueUpdate(projectId, issueId),
    data: patch,
  });
  return response.data;
}
